import { hasCapability, type User } from "../base";

export const complianceEvent = {
  read: (user: User) => hasCapability(user, "complianceEvent.read"),
  create: (user: User) => hasCapability(user, "complianceEvent.create"),
  update: (user: User) => hasCapability(user, "complianceEvent.update"),
};
